<section class="mobile-login-shell" [attr.lang]="language()">
  <nav class="login-nav" aria-label="Login navigation">
    <button type="button" class="nav-link" (click)="goHome()">{{ t('goHome') }}</button>
    <button type="button" class="nav-link" (click)="viewCatalog()">{{ t('viewCatalog') }}</button>
  </nav>

  <header>
    <h1>{{ t('title') }}</h1>
    <p>{{ t('subtitle') }}</p>
  </header>

  <label class="input-row">
    <span>{{ t('email') }}</span>
    <input
      type="email"
      [(ngModel)]="email"
      (ngModelChange)="clearError()"
      placeholder="customer@company.com"
      (keyup.enter)="submit()"
    />
  </label>

  <label class="input-row">
    <span>{{ t('password') }}</span>
    <input
      type="password"
      [(ngModel)]="password"
      (ngModelChange)="clearError()"
      placeholder="********"
      (keyup.enter)="submit()"
    />
  </label>

  @if (errorMessage) {
    <p class="login-error">{{ errorMessage }}</p>
  }

  <button type="button" [disabled]="loading" (click)="submit()">
    {{ loading ? t('loading') : t('signIn') }}
  </button>
</section>
